import { Migration } from "@mydocma/core/src/lib/migration";
import { IDBPDatabase } from "idb";
import { MmProjectDbCollections } from "../../mm-project-db-schema";

export const V8: Migration = {

  up(database: IDBPDatabase<unknown>) {
    database.createObjectStore(MmProjectDbCollections.plans,  { keyPath: 'Id' });
  },

};
